import { render, staticRenderFns } from "./B2buserDetails.vue?vue&type=template&id=28b9778a&scoped=true&"
import script from "./B2buserDetails.vue?vue&type=script&lang=js&"
export * from "./B2buserDetails.vue?vue&type=script&lang=js&"
import style0 from "./B2buserDetails.vue?vue&type=style&index=0&id=28b9778a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b9778a",
  null
  
)

export default component.exports